import { withInstallCityDeliveries } from "~/api/installCityDeliveries";
import type {
  DeliveryListResponse,
  PaymentListResponse,
} from "~/types/api/cart";

export default (axios: any, config: any) => ({
  // Где вызывается: сервер.
  async getDeliveryList(
    _redis: unknown = false,
    reset = false,
  ): Promise<DeliveryListResponse> {
    const { data } = await axios.get(
      `${config.API_URL}/cart/getDeliveryList`,
      reset ? { params: { clear_cache: true } } : undefined,
    );
    return withInstallCityDeliveries(data);
  },

  // Где вызывается: сервер.
  async getPaymentList(
    _redis: unknown = false,
    reset = false,
  ): Promise<PaymentListResponse> {
    const { data } = await axios.get(
      `${config.API_URL}/cart/getPaymentList`,
      reset ? { params: { clear_cache: true } } : undefined,
    );
    return data;
  },
});
